import Alpine from 'alpinejs';
import AlpineMask from '@alpinejs/mask';

Alpine.plugin(AlpineMask);

Alpine.start();
